<script>
import {
  CdrLink,
  CdrList,
  CdrText,
  IconExperiencesCamping,
  IconExperiencesHiking,
  IconExperiencesCycling,
  IconExperiencesClimbing,
  IconExperiencesSnowsports,
  IconExperiencesPaddling,
  IconExperiencesRunning,
  IconExperiencesFitness,
  IconExperiencesTravel,
  IconExperiencesClothing,
  IconExperiencesOutdoorBasics,
  IconExperiencesFamily,
} from '@rei/cedar';

export default {
  name: 'LandingNav',
  components: {
    CdrLink,
    CdrList,
    CdrText,
    IconExperiencesCamping,
    IconExperiencesHiking,
    IconExperiencesCycling,
    IconExperiencesClimbing,
    IconExperiencesSnowsports,
    IconExperiencesPaddling,
    IconExperiencesRunning,
    IconExperiencesFitness,
    IconExperiencesTravel,
    IconExperiencesClothing,
    IconExperiencesOutdoorBasics,
    IconExperiencesFamily,
  },
  data() {
    return {
      baseClassName: 'ea-nav-icons',
      navIcons: [{
        icon: 'IconExperiencesCamping',
        url: '/learn/c/camping',
        text: 'Camping',
      },
      {
        icon: 'IconExperiencesHiking',
        url: '/learn/c/hiking',
        text: 'Hiking',
      },
      {
        icon: 'IconExperiencesCycling',
        url: '/learn/c/cycling',
        text: 'Cycling',
      },
      {
        icon: 'IconExperiencesClimbing',
        url: '/learn/c/climbing',
        text: 'Climbing',
      },
      {
        icon: 'IconExperiencesSnowsports',
        url: '/learn/c/snowsports',
        text: 'Snowsports',
      },
      {
        icon: 'IconExperiencesPaddling',
        url: '/learn/c/watersports',
        text: 'Watersports',
      },
      {
        icon: 'IconExperiencesRunning',
        url: '/learn/c/running',
        text: 'Running',
      },
      {
        icon: 'IconExperiencesFitness',
        url: '/learn/c/fitness',
        text: 'Fitness',
      },
      {
        icon: 'IconExperiencesTravel',
        url: '/learn/c/travel',
        text: 'Travel',
      },
      {
        icon: 'IconExperiencesClothing',
        url: '/learn/c/clothing',
        text: 'Clothing',
      },
      {
        icon: 'IconExperiencesOutdoorBasics',
        url: '/learn/c/outdoor-basics',
        text: 'Outdoor Basics',
      },
      {
        icon: 'IconExperiencesFamily',
        url: '/learn/c/family',
        text: 'Family',
      },
      ],
    };
  },
};
</script>

<template>
  <section>
    <nav
      id="ea_nav-icons"
      :class="`${baseClassName}`"
    >
      <cdr-list
        :class="`${baseClassName}__grid`"
        cols="2 3@sm 4@md 6@lg"
      >
        <li
          v-for="(icon, i) in navIcons"
          :key="`icon-${i}`"
        >
          <cdr-link
            :href="icon.url"
            :class="`${baseClassName}__link`"
            modifier="standalone"
          >
            <div class="ea_nav-link">
              <component
                :is="icon.icon"
                size="large"
                :class="`${baseClassName}__icon`"
              />
              <cdr-text class="ea_nav-text">
                {{ icon.text }}
              </cdr-text>
            </div>
          </cdr-link>
        </li>
      </cdr-list>
    </nav>
  </section>
</template>

<style lang="scss">
  @import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

  $baseClassName: 'ea-nav-icons';

  .#{$baseClassName} {
    @include cdr-container;
    text-align: center;

    .#{$baseClassName}__grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      list-style: none;
      margin: 0 auto;
      padding: 0;
      @include cdr-sm-mq-up {
        max-width: 66.66667%;
      }
      & > * {
        flex-basis: 33.3334%;
        width: 33.3334%;
        max-width: 33.3334%;
        @include cdr-md-mq-up {
          flex-basis: 25%;
          width: 25%;
          max-width: 25%;
        }
        @include cdr-lg-mq-up {
          flex-basis: 16.66667%;
          width: 16.66667%;
          max-width: 16.66667%;
        }
      }
    }

    .#{$baseClassName}__icon {
      width: 8rem;
      height: 8rem;
      fill: $cdr-color-icon-emphasis;
    }

    .#{$baseClassName}__link {
      margin: 0 auto;
      margin-bottom: $cdr-space-two-x;
      &, &:hover {
        color: $cdr-color-text-primary;
      }
    }

  }
</style>
